import { Modal } from "@upstox/upstox-ui";
import React, { FunctionComponent } from "react";

type DisabledPopupProps = {
  title: string;
  show: boolean;
  onClose: () => void;
  zIndex?: number;
  withCloseButton?: boolean;
  footer?: React.ReactNode;
};

const DisabledPopup: FunctionComponent<DisabledPopupProps> = ({
  title,
  show = false,
  onClose,
  children,
  zIndex = 11,
  footer = null,
}) => {
  return (
    <>
      {show && (
        <Modal
          header={null}
          onClose={onClose}
          zIndex={zIndex}
          className="max-w-100 disabledPopup"
          footer={footer}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M7.99967 14.6667C7.07745 14.6667 6.21079 14.4917 5.39967 14.1417C4.58856 13.7917 3.88301 13.3167 3.28301 12.7167C2.68301 12.1167 2.20801 11.4112 1.85801 10.6C1.50801 9.78893 1.33301 8.92226 1.33301 8.00004C1.33301 7.07782 1.50801 6.21115 1.85801 5.40004C2.20801 4.58893 2.68301 3.88337 3.28301 3.28337C3.88301 2.68337 4.58856 2.20837 5.39967 1.85837C6.21079 1.50837 7.07745 1.33337 7.99967 1.33337C8.9219 1.33337 9.78856 1.50837 10.5997 1.85837C11.4108 2.20837 12.1163 2.68337 12.7163 3.28337C13.3163 3.88337 13.7913 4.58893 14.1413 5.40004C14.4913 6.21115 14.6663 7.07782 14.6663 8.00004C14.6663 8.92226 14.4913 9.78893 14.1413 10.6C13.7913 11.4112 13.3163 12.1167 12.7163 12.7167C12.1163 13.3167 11.4108 13.7917 10.5997 14.1417C9.78856 14.4917 8.9219 14.6667 7.99967 14.6667ZM7.99967 13.3334C8.59967 13.3334 9.17745 13.2362 9.73301 13.0417C10.2886 12.8473 10.7997 12.5667 11.2663 12.2L3.79967 4.73337C3.43301 5.20004 3.15245 5.71115 2.95801 6.26671C2.76356 6.82226 2.66634 7.40004 2.66634 8.00004C2.66634 9.48893 3.18301 10.75 4.21634 11.7834C5.24967 12.8167 6.51079 13.3334 7.99967 13.3334ZM12.1997 11.2667C12.5663 10.8 12.8469 10.2889 13.0413 9.73337C13.2358 9.17782 13.333 8.60004 13.333 8.00004C13.333 6.51115 12.8163 5.25004 11.783 4.21671C10.7497 3.18337 9.48856 2.66671 7.99967 2.66671C7.39967 2.66671 6.8219 2.76393 6.26634 2.95837C5.71079 3.15282 5.19967 3.43337 4.73301 3.80004L12.1997 11.2667Z"
                fill="#6A6A6A"
              />
            </svg>
            {children}
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            onClick={() => onClose()}
            cursor="pointer"
          >
            <path
              d="M4.26732 12.6667L3.33398 11.7334L7.06732 8.00004L3.33398 4.26671L4.26732 3.33337L8.00065 7.06671L11.734 3.33337L12.6673 4.26671L8.93398 8.00004L12.6673 11.7334L11.734 12.6667L8.00065 8.93337L4.26732 12.6667Z"
              fill="black"
            />
          </svg>
        </Modal>
      )}
    </>
  );
};

export default DisabledPopup;
